import { requireNativeModule } from 'expo'

export default requireNativeModule('VoltraModule')
